import * as Hooks from 'preact/hooks';
import { ConfigurationPostData } from '../../data/shareConfiguration';
import { LayoutPostData } from '../../data/shareLayout';
import { useSharingLinkAsync } from './useSharingLinkAsync';

/** Serve a sharing URL, and provide a function to be called whenever a new one needs to be
 * generated. Presumably that's right before we actually need to use a sharing link (e.g. opening
 * the save and share drawer or opening the exit screen)
 */
export function useSaveLinkState(generateNewLayout: () => LayoutPostData, currentUrl: string) {
    const [currentLayout, setCurrentLayout] = Hooks.useState<LayoutPostData | undefined>(undefined);
    const [arView, setArView] = Hooks.useState(false);

    const generateNewSharingUrl = (ar: boolean) => {
        setCurrentLayout(generateNewLayout());
        setArView(ar);
    };

    const sharingUrlRequest = useSharingLinkAsync(currentUrl, arView, currentLayout);

    return {
        sharingUrlRequest,
        generateNewSharingUrl,
    };
}

export function useSaveConfigurationLinkState(
    generateNewConfiguration: () => ConfigurationPostData | undefined,
    currentUrl: string,
    ar: boolean,
) {
    const [currentConfiguration, setCurrentConfiguration] = Hooks.useState<
        ConfigurationPostData | undefined
    >(undefined);

    const generateNewSharingUrl = () => {
        setCurrentConfiguration(generateNewConfiguration());
    };
    const sharingUrlRequest = useSharingLinkAsync(currentUrl, ar, currentConfiguration);

    return {
        sharingUrlRequest,
        generateNewSharingUrl,
    };
}
